export default __webpack_public_path__ + "static/sign-new-480c5ec31f84fcef9322937ae51f34b5.jpg";